module.exports = __webpack_public_path__ + "static/media/viettelpay.36261968.png";